<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header bg-primary">
          <h4 class="card-title text-white mb-0">{{ $t('VEHICLE_DETAILS') }}</h4>
        </div>
        <div class="card-body pt-3">
          <validation-observer v-slot="{ handleSubmit, reset }">
            <form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="reset">
              <div class="row">
                <div class="col-sm-12 form-group">
                  <validation-input label="License plate" rules="required">
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="data.CS_DATA.LICENSE_PLATE" />
                      <div class="input-group-append cursor-pointer" title="Search License plate" @click="searchVehicle">
                        <span class="input-group-text"><i class="mdi mdi-search-web"></i></span>
                      </div>
                    </div>
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Category" rules="required">
                    <select class="form-control custom-select" v-model="data.CS_DATA.CATEGORY">
                      <option v-for="o in lovs.CATEGORY" :key="o.value" :value="o.value">
                        {{ o.text }}
                      </option>
                    </select>
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Year of manufacture" rules="required">
                    <cleave-input type="date" v-model="data.CS_DATA.YEAR" placeholder="__/____" />
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Manufacturer" rules="required">
                    <select class="form-control custom-select" v-model="data.CS_DATA.MANUFACTURER">
                      <option v-for="o in lovs.MANUFACTURER" :key="o.value" :value="o.value">
                        {{ o.text }}
                      </option>
                    </select>
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Model" rules="required">
                    <select class="form-control custom-select" v-model="data.CS_DATA.MODEL">
                      <option v-for="o in lovs.MODEL" :key="o.value" :value="o.value">
                        {{ o.text }}
                      </option>
                    </select>
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Engine capacity (cc)" rules="required">
                    <input class="form-control" v-model="data.CS_DATA.CAPACITY" />
                  </validation-input>
                </div>
                <div class="col-sm-12 form-group">
                  <validation-input label="Value" rules="required|positive">
                    <cleave-input type="numeral" v-model="data.CS_DATA.VALUE" />
                  </validation-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 d-flex">
                  <div class="ml-auto">
                    <button type="submit" class="btn btn-primary">Next</button>
                  </div>
                </div>
              </div>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    lovs: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      config: {
        wrap: true,
        altFormat: 'd.m.Y',
        altInput: true,
        // allowInput: true,
        enableTime: false
      }
    };
  },
  methods: {
    ...mapActions('motor', ['searchLicensePlateAction']),
    onSubmit() {
      this.$emit('next');
    },
    async searchVehicle() {
      await this.searchLicensePlateAction(this.data.CS_DATA.LICENSE_PLATE);
    }
  }
};
</script>
